<template>
  <modern-pie-chart
    :title="title"
    :series="series"
    :labels="labels"
    :colors="chartColors"
    :height="300"
    :show-donut="false"
    :show-data-labels="true"
    :show-legend="true"
    :display-mode="displayMode"
  />
</template>

<script>
import { mapGetters } from "vuex";
import { companyDSARPerReceivingMeans } from "../../../../api/charts";
import { colors } from "../commons";
import ModernPieChart from "../ModernPieChart.vue";
import { displayModeMixin } from "../displayModeMixin";

export default {
  name: "DsarPerReceivingMeans",
  mixins: [displayModeMixin],
  components: {
    ModernPieChart,
  },
  props: {
    company: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      title: "Qtd. Solicitações x Meio Recebimento",
      series: [],
      labels: [],
      chartColors: [],
    };
  },

  computed: {
    ...mapGetters(["classificationMaps"]),
  },

  async created() {
    const response = await companyDSARPerReceivingMeans(this.company);
    const data = response.data;

    let includeNullColor = false;

    for (const item of data) {
      if (item._id === null) {
        this.labels.unshift("Sem Classificação");
        this.series.unshift(item.count);
        includeNullColor = true;
      } else {
        this.labels.push(this.classificationMaps.receivingMeans[item._id]);
        this.series.push(item.count);
      }
    }

    this.chartColors = colors.default(includeNullColor);
  },
};
</script>
